import { render, staticRenderFns } from "./DashboardTvDiario.vue?vue&type=template&id=50620037"
import script from "./DashboardTvDiario.vue?vue&type=script&lang=ts"
export * from "./DashboardTvDiario.vue?vue&type=script&lang=ts"
import style0 from "./DashboardTvDiario.vue?vue&type=style&index=0&id=50620037&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports